import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { GetAllLinksResponse } from '../models/get-all-links-response';

@Injectable({
  providedIn: 'root'
})
export class LinkService {

  constructor(private http: HttpClient) { }

    getLinks() {
      return this.http.get<GetAllLinksResponse>(environment.apiUrl + '/links');
    }
  
    removeLink(pan: string) {
      return this.http.delete(environment.apiUrl + `/links/${pan}`);
    }
}
